const timeOptions = [
  // Minutos (valores numéricos: 1, 2, 3, 4, 5, 10, 15, 20, 30, 60)
  { label: "1 min", value: "1min" },
  { label: "2 min", value: "2min" },
  { label: "3 min", value: "3min" },
  { label: "4 min", value: "4min" },
  { label: "5 min", value: "5min", separator: true },
  { label: "10 min", value: "10min" },
  { label: "15 min", value: "15min" },
  { label: "20 min", value: "20min" },
  { label: "30 min", value: "30min" },
  { label: "1 Hora", value: "60min" },
  { label: "2 Horas", value: "120min" },
  { label: "4 Horas", value: "240min" },
  // Períodos maiores (valores originais mantidos para compatibilidade)
  { label: "1 Dia", value: "1D", separator: true },
  { label: "1 Semana", value: "1W" },
  { label: "1 Mês", value: "1M" },
];

export default timeOptions;
